import { BulkActions } from '@common/components/Actions/BulkActions';
import { Action } from '@common/types/actions';
import { createActions } from '@common/types/actions';
import { Clip } from '@features/Clip';
import { useSelectedCollection } from '@features/Collection/hooks';
import { Collection } from '@features/Collection/types';
import { getBookmarkedCollections } from '@pages/Home/constants/avenueConfigs';
import { HeartFilledIcon, HeartIcon, Share2Icon } from '@radix-ui/react-icons';
import { Flex } from '@radix-ui/themes';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

type BlockData = Collection | Clip;

export const ActionsBlock = () => {
    const { selectedCollection } = useSelectedCollection();
    return (
        <ActionsBlockContent
            key={selectedCollection.proscopeId}
            collection={selectedCollection}
        />
    );
};

const ActionsBlockContent = ({ collection }: { collection: Collection }) => {
    const { t } = useTranslation('table'); // todo: update this
    const bookmarks = getBookmarkedCollections();

    const [isBookmarked, setIsBookmarked] = useState(() =>
        bookmarks.includes(collection.proscopeId),
    );

    const bulkActions: Action<BlockData>[] = useMemo(
        () =>
            createActions<BlockData>([
                {
                    label: () =>
                        isBookmarked
                            ? t('actions.unbookmark')
                            : t('actions.bookmark'),
                    color: 'gray',
                    icon: () =>
                        isBookmarked ? (
                            <HeartFilledIcon color={undefined} />
                        ) : (
                            <HeartIcon color='gray' />
                        ),
                    onClick: () => setIsBookmarked((prev) => !prev),
                },
                {
                    label: t('actions.export'),
                    onClick: (items) => {
                        console.log('Export these:', items);
                    },
                    color: 'gray',
                    icon: <Share2Icon />,
                },
            ]),

        [isBookmarked, t],
    );

    return (
        <Flex gap={'2'} mt={'5'}>
            <BulkActions
                actions={bulkActions}
                selectedItems={[]}
                size={'3'}
                variant='surface'
            />
        </Flex>
    );
};
